export default {
  setSearchText (state: {[key:string]: string}, payload: string) {
    state.searchText = payload
  },
  setOrderName (state: {[key:string]: string}, name: string) {
    state.orderName = name
  },
  setSortAsc (state: {[key:string]: boolean}, sort: boolean) {
    state.sortAsc = sort
  }
}
